/* eslint-disable array-callback-return */
import React, { useEffect, useState, Fragment } from "react";

import { useSelector, useDispatch } from "react-redux";
import ReactTooltip from "react-tooltip";

import {
  accessActions
  //  userActions
} from "../../redux/actions";

import { helperFunction } from "../../constant/helper";
import Button from "../../component/button/Button";
import Card from "../../component/card/Card";
import CreateAccessModel from "./CreateAccessModel";
import TopInput from "./TopInput";
import UserList from "./UserList";
import Starter from "../../component/Starter";

const moduleTypeArray = {
  HR_MODULE: "HR MODULE",
  RULES_MODULE: "RULES MODULE",
  ADMIN_MODULE: "ADMIN MODULE",
  REGISTER_MODULE: "REGISTER MODULE",
  ATTENDANCE_MODULE: "ATTENDANCE MODULE"
};

const Access = () => {
  const loginType = localStorage.loginType;
  // const localLocationId = localStorage.locationId;
  const dispatch = useDispatch();

  const [workerId, setWorkerId] = useState("");
  const [moduleType, setModuleType] = useState("");
  const [allAccesses, setAllAccesses] = useState([]);
  const [getByLocationId, setGetByLocationId] = useState("");
  const [selectUserId, setSelectUserIdChange] = useState("");
  const [userByLocationId, setUserByLocationId] = useState("");
  const [selectedUserName, setSelectedUserName] = useState("");
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [selectedLocationName, setSelectedLocationName] = useState(
    ""
  );

  const showModuleTypeOptions = Object.values(moduleTypeArray).map(
    (type, index) => (
      <option value={type} key={index}>
        {type}
      </option>
    )
  );

  // ?access useSelector
  const {
    accessError,
    accessResponse,
    accesses,
    accessLoading,
    locationId,
    accessCreateLoading
  } = useSelector((state) => state.access);

  // ?location useSelector
  const { locations } = useSelector((state) => state.location);

  // ?auth, user useSelector
  const { currentUser } = useSelector((state) => state.auth);
  const { allUserForAccess } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(accessActions.setAccessLoading(false));
    dispatch(accessActions.setAccessCreateLoading(false));
    dispatch(accessActions.clearAccessErrors());
    dispatch(accessActions.clearAccessResult());
    // setTimeout(() => {
    //   if (
    //     currentUser.workerDepartment !== "SUPER ADMIN" &&
    //     currentUser.workerDesignation !== "SUPER ADMIN"
    //   ) {
    //     dispatch(
    //       userActions.getAllUsersForAccess(loginType, localLocationId)
    //     );
    //   }
    // }, 2000);

    return () => {
      dispatch(accessActions.setAccessCreateLoading(false));
      dispatch(accessActions.setAccessLoading(false));
      dispatch(accessActions.clearAccessErrors());
      dispatch(accessActions.clearAccessResult());
      // dispatch(accessActions.unmountAccessData());
    };
  }, []);

  useEffect(() => {
    if (accessError) {
      helperFunction.toastHelper("error", accessError);
    }
    if (accessResponse) {
      helperFunction.toastHelper("success", accessResponse);
    }
  }, [accessError, accessResponse]);

  useEffect(() => {
    setAllAccesses(accesses);
  }, [accesses]);

  useEffect(() => {
    setGetByLocationId(getByLocationId);
  }, [getByLocationId]);

  useEffect(() => {
    setGetByLocationId(locationId);
  }, [locationId]);

  const onLocationChange = (e) => {
    const { value } = e.target;
    setGetByLocationId(value);
    dispatch(accessActions.setAccessLoading(true));
    dispatch(accessActions.clearAccessErrors());
    dispatch(accessActions.clearAccessResult());
    dispatch(accessActions.getAccessData(value, loginType));
  };

  const onAddAccess = (e) => {
    e.preventDefault();
    const accessData = {
      accessGivenByName:
        currentUser.workerFirstName + " " + currentUser.workerSurname,
      userId: selectUserId,
      moduleType,
      workerId,
      locationId: selectedLocationId,
      locationName: selectedLocationName,
      workerFullName: selectedUserName,
      accessGivenBy: currentUser.id
    };

    dispatch(accessActions.setAccessCreateLoading(true));
    dispatch(accessActions.clearAccessErrors());
    dispatch(accessActions.clearAccessResult());
    dispatch(
      accessActions.createAccessControl(accessData, loginType)
    );
  };

  const onSelectedLocationIdChange = (e) => {
    const { value } = e.target;
    setSelectedLocationId(value);
    locations.find((locationsData, i) => {
      if (locationsData._id === value) {
        setSelectedLocationName(locationsData.locationName);
      }
    });
  };

  const onSelectedUserChange = (e) => {
    const { value } = e.target;
    setSelectUserIdChange(value);
    allUserForAccess.find((accessUserData, i) => {
      if (accessUserData._id === value) {
        const workerFullName =
          accessUserData.workerFirstName +
          " " +
          accessUserData.workerSurname;
        setSelectedUserName(workerFullName);
        setWorkerId(accessUserData.workerId);
      }
    });
  };

  const onDeleteAccess = (e, accessData) => {
    e.preventDefault();
    const accessRemove = {
      locationName: accessData.locationName,
      locationId: accessData.locationId,
      moduleType: accessData.moduleType,
      accessId: accessData._id,
      workerFullName: accessData.workerFullName,
      userId: accessData.userId
    };
    dispatch(accessActions.clearAccessErrors());
    dispatch(accessActions.clearAccessResult());
    dispatch(
      accessActions.deleteAccessControl(accessRemove, loginType)
    );
  };

  const getUserByLocationId = (e) => {
    const { value } = e.target;
    setUserByLocationId(value);
    dispatch(accessActions.getAllUsersForAccess(loginType, value));
  };

  return (
    <Starter
      topBarTitle="Add Access"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Access Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Access</a>
          </li>
          <li className="breadcrumb-item active">Add Access</li>
        </Fragment>
      }
    >
      <ReactTooltip
        id="createAccess"
        place="top"
        effect="solid"
        type="info"
      >
        Click to Add Access
      </ReactTooltip>
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <Button
          data-tip
          type="button"
          data-for="createAccess"
          isBackgroundColor={false}
          title="Add Access"
          icon="mdi mdi-database-plus mr-2"
          onClick={(e) => {}}
          data-toggle="modal"
          data-target="#add_access"
          className="btn text-white btn-block btn-primary float-right"
        />
        <CreateAccessModel
          moduleType={moduleType}
          locations={locations}
          onAddAccess={onAddAccess}
          setModuleType={(e) => setModuleType(e.target.value)}
          selectedLocationId={selectedLocationId}
          showModuleTypeOptions={showModuleTypeOptions}
          setSelectedLocationId={onSelectedLocationIdChange}
          loading={accessCreateLoading}
          allUserForAccess={allUserForAccess}
          setSelectUserChange={onSelectedUserChange}
          selectUserId={selectUserId}
          currentUser={currentUser}
          userByLocationId={userByLocationId}
          setUserByLocationId={getUserByLocationId}
        />
      </div>
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12">
          <Card>
            <TopInput
              setGetByLocationId={onLocationChange}
              getByLocationId={getByLocationId}
              currentUser={currentUser}
              locations={locations}
            />
            <div className="table-responsive">
              <table
                className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
                id="products-datatable"
              >
                <thead className="thead-light">
                  <tr>
                    <th style={{ width: "20px" }}>#</th>
                    <th>Employee Name</th>
                    <th>Location Name</th>
                    <th>Module Type</th>
                    <th>Added By</th>
                    <th>Added on</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <UserList
                    userList={allAccesses}
                    accessLoading={accessLoading}
                    onDeleteAccess={onDeleteAccess}
                  />
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      </div>
    </Starter>
  );
};

export default Access;
